<template>
    <div>
        <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
            
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <routes-table title="Lista de Rutas"></routes-table>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import RoutesTable from './Tables/RoutesTable'
  export default {
    name: 'routes',
    components: {
      RoutesTable
    }
  };
</script>
<style></style>
